function secureUnitInterval() {
  const value = new Uint32Array(1);
  crypto.getRandomValues(value);
  return value[0] / 4294967296;
}

export function shuffledSample<T>(items: T[], requestedCount: number, random = secureUnitInterval): T[] {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.max(0, Math.min(.999999999999, random())) * (index + 1));
    [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
  }
  const count = Math.max(0, Math.min(Math.round(requestedCount), result.length));
  return result.slice(0, count);
}
